module.exports = __webpack_public_path__ + "static/media/whatsthatlogo.b0d9043e.svg";